import { render, staticRenderFns } from "./StatisticsCancels.vue?vue&type=template&id=740f9472&scoped=true&"
import script from "./StatisticsCancels.vue?vue&type=script&lang=js&"
export * from "./StatisticsCancels.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCancels.vue?vue&type=style&index=0&id=740f9472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f9472",
  null
  
)

export default component.exports